import React from "react";
import { Link } from "react-router-dom";
import { ActivitiesData } from "../pages/types";
import {dateFormat} from "../units";

const classnames = require('classnames');

interface ItemProps extends ActivitiesData{
    type:string
}

const Item:React.FC<ItemProps> = (props) => {
    return <Link className="active-item" to={`/home/activity/${ props.id }/detail`}>
        <div className="img-box">
            <div className="bg" style={{ backgroundImage:`url(${ props.coverUrl })` }}/>
        </div>
        <div className="text">
            <h3>{ props.activityTitle }</h3>
            <div className="flex">
                <p><span className="iconfont">&#xe616;</span> {  dateFormat(props.startTime) } </p>
                <p className={classnames("_btn",{ "disabled": props.statusCode !== 1 })}>{ props.statusCode === 1 ? '马上参与' : '活动已结束' }</p>
            </div>
        </div>
    </Link>
}

interface ActiveList {
    lists:Array<ActivitiesData>,
    type?:string
}

const ActivityList:React.FC<ActiveList> = (props) => {

    const { type } = props;


    return <div className="active-list">
        {
            props.lists.map((item,index) =>{
                return <React.Fragment key={index}>
                    <Item type={ type || 'activityDetail' } {...item}/>
                </React.Fragment>
            })
        }
    </div>
}

export default ActivityList;
